import { render, staticRenderFns } from "./Artifacts.vue?vue&type=template&id=68b3253d&lang=pug&"
import script from "./Artifacts.vue?vue&type=script&lang=ts&"
export * from "./Artifacts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports